import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from  '../../img/trail-page-bg.webp'
import modalBg from '../../img/waterfall-modal-bg.svg'
import contentImg1 from '../../img/markov_2.webp'
import {Preloader, SpriteSvg} from '../../components'
import sun2 from "../../img/sun2.png";
import sun3 from "../../img/sun3.png";
import sun4 from "../../img/sun4.png";
import sun5 from "../../img/sun5.png";
import sun6 from "../../img/sun6.png";
import {useMousePosition} from '../../utils'
import bgImg1 from "../../img/trail-bgImg1.webp";
import bgImg4 from "../../img/trail-bgImg4.webp";
import bgImg3 from "../../img/trail-bgImg3.webp";
import bgImg5 from "../../img/trail-bgImg6.webp";

const TrailPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	isRouteTraveled,
	setIsRouteTraveled,
	trailPage,
	afterTrailGamePage,
}) => {

const [isVisibleContent, setIsVisibleContent] = useState(false)
const [isVisiblePage, setIsVisiblePage] = useState(true)
	const [isVisibleGame, setIsVisibleGame] = useState(false)
const [modalContentChange, setModalContentChange] = useState(false)

	useEffect(()=> {
		window.TN_ROPE.run("#area");
		setTimeout(()=> {
			setIsVisibleContent(true)
		},7000)
	},[])

	const handleMeadowGame = () => {
		setIsVisiblePage(false)
		setIsVisibleGame(true)
		window.TN_ROPE.showStartMessage()
		window.TN_ROPE.successCallback = () => {
			setIsRouteTraveled([...isRouteTraveled, trailPage])
			setIsVisibleGame(false)
			handleNextPage(afterTrailGamePage)
		}
	}
	const position = useMousePosition()
	return (
		<>
		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>
			<div id='area' className={cn(
				'game-wrap',
				isVisibleGame && 'active'
			)}></div>

			{isVisiblePage &&
		<div className={cn(
					 'full-page',
					 'waterfall-page',
					 isLoaded && 'active'
				 )}
		>
			<div className="page-bg left-sun">
				<img className='bg-img' src={pageBg} alt=""/>
				<img className='sun2' style={{transform: `translate(-${position.x / 10}px, -${position.y / 10}px)`}} src={sun2} alt=""/>
				<img className='sun3' style={{transform: `translate(-${position.x / 25}px, -${position.y / 25}px)`}} src={sun3} alt=""/>
				<img className='sun4' style={{transform: `translate(-${position.x / 50}px, -${position.y / 50}px)`}} src={sun4} alt=""/>
				<img className='sun5'  src={sun5} alt=""/>
				<img className='sun6' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px) rotate(-91deg)`}} src={sun6} alt=""/>
				<img className='trail-bgImg1' style={{transform: `translate(-${position.x / 150}px, -${position.y / 350}px)`}} src={bgImg1} alt=""/>
				<img className='trail-bgImg2' style={{transform: `translate(${position.x / 350}px, ${position.y / 350}px)`}} src={bgImg4} alt=""/>
				<img className='trail-bgImg3' style={{transform: `translate(-${position.x / 450}px, -${position.y / 350}px)`}} src={bgImg3} alt=""/>
				<img className='trail-bgImg6' style={{transform: `translate(-${position.x / 450}px, -${position.y / 350}px)`}} src={bgImg5} alt=""/>
			</div>

			<div className={cn(
						 'page-content',
						 isVisibleContent &&
						 'active'
					 )}>

				<div className={cn(
					'modal',
					modalContentChange &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>


					<div className={cn(
						'modal-content'
					)}
					>
						<div className="text">
							<p className='mg-b-24'>Ну что, {name}, ты в норме? Вижу, что начинается скользкая горная тропа! Пора воспользоваться верёвками для страховки. Они с тобой или благополучно забыты?</p>
							<p className='mg-b-24'>Может, пора оставить затею с подъемом? Мы почти прошли середину пути, ещё есть шанс вернуться!</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> setModalContentChange(true)} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<span>Я не отступлю!</span>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'modal',
					!modalContentChange &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>

					<div className={cn(
						'modal-content',
					)}
					>
						<div className="text">
							<p className='mg-b-24'>Вижу, ты так просто не отступишь от мечты! Молодец! Возможно, именно ты покоришь этот пик.</p>
								<p className='mg-b-24'>Смотри, впереди туристки. Попробуй добыть у них верёвки с карабинами. Без этого тебе не подняться.</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> handleMeadowGame()} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<p>Размотать клубок</p>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'content',
					'center',
				)}>
					<div className="img-wrap">
						<img src={contentImg1} alt=""/>
					</div>

				</div>

			</div>

		</div>
			}
		</>
	)
}

export default TrailPage